<template>
  <div
    ref="form"
    class="v-drop-zone"
    :class="{ 'is-hover': isHover }"
    @drag.prevent.stop
    @dragstart.prevent.stop
    @dragover.prevent.stop="onEnter"
    @dragenter.prevent.stop="onEnter"
    @dragend.prevent.stop="onLeave"
    @dragleave.prevent.stop="onLeave"
    @drop.prevent.stop="onDrop"
  >
    <input
      ref="file"
      type="file"
      :accept="fileType.accepted"
      @change="onFileChange"
    />
    <i class="el-icon-upload" />
    <span>{{ placeholder }}</span>
  </div>
</template>

<script>
export default {
  name: 'DropZone',
  props: {
    placeholder: { type: String, default: '' },
    type: { type: String, default: 'image' }
  },
  data() {
    return {
      isHover: false,
      fileType: {
        accepted: '',
        errorMessage: '',
        regex: ''
      }
    }
  },
  watch: {
    type: {
      immediate: true,
      handler(val) {
        switch (val) {
          case 'image':
            this.fileType.accepted = 'image/*'
            this.fileType.errorMessage = 'فقط تصاویر قابل قبول هستند'
            this.fileType.regex = /image\/*/
            break
          case 'excel':
            this.fileType.accepted =
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
            this.fileType.errorMessage = 'فقط فایل های اکسل قابل قبول هستند'
            this.fileType.regex = /application\/*/
            break
          default:
            this.fileType.accepted = '*'
            this.fileType.errorMessage = 'فایل غیر مجاز است'
            this.fileType.regex = ''
            break
        }
      }
    }
  },
  methods: {
    onEnter() {
      this.isHover = true
    },
    onLeave() {
      this.isHover = false
    },
    onDrop(event) {
      this.onLeave()
      let file = event.dataTransfer.files[0]
      if (file && file.type.match(this.fileType.regex)) {
        this.$emit('change', file)
      } else {
        this.$message.warning(this.fileType.errorMessage)
      }
    },
    onFileChange(event) {
      this.$emit('change', event.target.files[0])
      event.target.value = ''
    }
  }
}
</script>

<style lang="scss">
.v-drop-zone {
  position: relative;
  //background-color: #f8f9fa;
  border: dashed 1px #ced4da;
  color: #adb5bd;
  text-align: center;
  padding: 30px 20px;
  border-radius: 5px;
  &.is-hover {
    border-color: #18d6b5;
    color: #18d6b5;
  }
  input[type='file'] {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    font-size: 100px;
    opacity: 0;
    color: transparent;
    z-index: 10;
    cursor: pointer;
  }
  i {
    font-size: 40px;
  }
  span {
    display: block;
  }
}

$prefix: v-image-picker;
.#{$prefix} {
  position: relative;
  transition: all 0.3s ease;
  height: 134px;
  .v-drop-zone {
    padding: 15px;
    transition: padding 0.3s ease;
    height: 100%;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
  }
  &.#{$prefix}-has-preview {
    .v-drop-zone {
      padding: 34px 130px 34px 20px;
    }
  }

  .#{$prefix}-preview {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 10;
  }

  .#{$prefix}-preview-image {
    width: 140px;
    height: 112px;
    background-color: white;
    border-radius: 5px;
    background-size: cover;
    background-position: center;
    border: solid 1px #ccc;
    margin: auto;
  }

  .#{$prefix}-delete {
    font-size: 15px;
    padding: 7px;
    background-color: rgba(255, 0, 85, 0.95);
    color: white;
    cursor: pointer;
    border-radius: 10px;
    position: absolute;
    top: 5px;
    right: 5px;
  }

  .#{$prefix}-preview-text {
    font-size: 10px;
    margin: 3px 0 0;
    color: #0cc7a1;
    text-align: center;
  }

  &[data-status='success'] {
    background-color: #f5fffd;
    border: dashed 1px #5ee2c7;
    text-align: center;
    border-radius: 5px;
    padding: 10px;

    .#{$prefix}-preview {
      position: static;
    }

    .#{$prefix}-delete {
      display: none;
    }

    .v-drop-zone {
      display: none;
    }
  }

  &[data-status='error'] {
    .v-drop-zone {
      border-color: #ff586e;
      color: #ff586e;
      cursor: pointer;
    }
  }
  &.mini {
    height: 130px;
    width: 130px;
    .v-drop-zone {
      padding: 0;
      background: #f5f5f5;
    }
    &.#{$prefix}-has-preview {
      .v-drop-zone {
        display: none;
      }
    }
    .#{$prefix}-preview {
      position: relative;
      top: initial;
      right: initial;
      z-index: 10;
      width: 100% !important;
      height: 100% !important;
    }
    .#{$prefix}-preview-image {
      width: 100% !important;
      height: 100% !important;
    }
  }
}
.#{$prefix}.small-holder {
  height: 100px;

  &.#{$prefix}-has-preview {
    .v-drop-zone {
      padding: 34px 20px 34px 20px;
    }
  }

  .#{$prefix}-preview-image {
    width: 80px;
    height: 80px;
  }

  &[data-status='success'] {
    background-color: #f5fffd;
    border: dashed 1px #5ee2c7;
    text-align: center;
    border-radius: 5px;
    padding: 10px;
  }
}
</style>

